import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Search from '../../../component/common/Search';
import { withRouter } from 'react-router-dom';
import ChatMessagesContainer from '../ChatMessagesContainer';
import { connect } from 'react-redux';
import {
  changeActiveChat,
  chatCompanyLoadChatsSuccess,
  fetchCompanyChats,
  fetchNewCompanyChat,
  fetchReplaceOrAddCompanyChat,
} from '../actions';
import ChatListItem from '../../../component/chat/ChatListItem';
import ChatLoadingSpinner from '../../../component/chat/ChatLoadingSpinner';
import InfiniteScroll from '../../../component/common/InfiniteScroll';

export class ChatCompanyContainer extends Component {
  static propTypes = {
    history: PropTypes.shape({
      location: PropTypes.object.isRequired,
      push: PropTypes.func.isRequired,
    }),
  };

  state = {
    chatActive: null,
    limit: 20,
    search: '',
  };

  chatListContainerRef = React.createRef();
  chatListRef = React.createRef();

  wsCompanyChannelOnChatCreated = (res) => {
    this.props.fetchNewChat(this.props.activeCompanyId, res.data.chatId);
  };

  wsCompanyChannelOnNewChatMessage = (res) => {
    this.props.fetchReplaceOrAddChat(this.props.activeCompanyId, res.data.chatId);
  };

  onFetchAllChats = (page) => {
    this.props.fetchAllChats(
      this.props.activeCompanyId,
      this.props.activeCompany.type,
      {
        page,
        limit: this.state.limit,
        search: this.state.search,
      },
      page === 1
    );
  };

  onSearchChange = (search) => {
    this.setState({ search });
  };

  componentDidMount() {
    if (this.props.wsCompanyChannel) {
      this.props.wsCompanyChannel.bind('chatCreated', this.wsCompanyChannelOnChatCreated);
      this.props.wsCompanyChannel.bind('newChatMessage', this.wsCompanyChannelOnNewChatMessage);
    }
    if (this.props.chats.length > 0) {
      this.props.selectChat(this.props.chats[0]);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.wsCompanyChannel && this.props.wsCompanyChannel) ||
      (prevProps.wsCompanyChannel &&
        this.props.wsCompanyChannel &&
        this.props.wsCompanyChannel.name !== prevProps.wsCompanyChannel.name)
    ) {
      this.props.wsCompanyChannel.bind('chatCreated', this.wsCompanyChannelOnChatCreated);
      this.props.wsCompanyChannel.bind('newChatMessage', this.wsCompanyChannelOnNewChatMessage);
    }

    if (
      (prevProps.chats.length === 0 && this.props.chats.length > 0) ||
      // When search/filter totalChats is changed before loading flag is set to false
      (prevProps.totalChats !== this.props.totalChats && this.props.chatsLoading)
    ) {
      this.props.selectChat(this.props.chats[0]);
    }
  }

  componentWillUnmount() {
    if (this.props.wsCompanyChannel) {
      this.props.wsCompanyChannel.unbind('chatCreated', this.wsCompanyChannelOnChatCreated);
      this.props.wsCompanyChannel.unbind('newChatMessage', this.wsCompanyChannelOnNewChatMessage);
    }
    this.props.selectChat(null);
    this.props.cleanCompanyChats();
  }

  render() {
    const { activeChat } = this.props;
    const activeChatId = activeChat ? activeChat._id : null;
    const chatList = this.props.chats.map((chat) => (
      <ChatListItem
        key={chat._id}
        activeCompanyId={this.props.activeCompanyId}
        chatActiveId={activeChatId}
        chat={chat}
        onClick={() => {
          if (chat._id !== activeChatId) {
            this.props.selectChat(chat);
          }
        }}
      />
    ));

    if (this.props.chatsLoading) {
      chatList.push(<ChatLoadingSpinner key={'loading-spinner'} />);
    }

    return (
      <div className="messages-container">
        <InfiniteScroll
          containerRef={this.chatListContainerRef}
          contentRef={this.chatListRef}
          load={this.onFetchAllChats}
          loading={this.props.chatsLoading}
          itemsCount={this.props.chats.length}
          totalCount={this.props.totalChats}
          search={this.state.search}
        >
          <div ref={this.chatListContainerRef} className="messages-chat-rooms">
            <div className="messages-heading">
              <h3>All messages</h3>
              <Search search={this.state.search} setSearch={this.onSearchChange} />
            </div>
            <div ref={this.chatListRef} className="chat-previews">
              {chatList}
            </div>
          </div>
        </InfiniteScroll>
        {this.props.activeChat && (
          <ChatMessagesContainer history={this.props.history} chat={this.props.activeChat} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeCompanyId: state.dashboard.activeCompanyId,
  activeCompany: state.dashboard.company,
  wsCompanyChannel: state.dashboard.ws.companyChannel,
  chats: state.dashboard.chats.all.data.items,
  totalChats: state.dashboard.chats.all.data.totalCount,
  chatsLoading: state.dashboard.chats.all.loading,
  activeChat: state.dashboard.chats.activeChat,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllChats: (companyId, companyType, params, isFirstPage) =>
    dispatch(fetchCompanyChats(companyId, companyType, params, isFirstPage)),
  fetchNewChat: (companyId, chatId) => {
    dispatch(fetchNewCompanyChat(companyId, chatId));
  },
  fetchReplaceOrAddChat: (companyId, chatId) => {
    dispatch(fetchReplaceOrAddCompanyChat(companyId, chatId));
  },
  selectChat: (chat) => {
    dispatch(changeActiveChat(chat));
  },
  cleanCompanyChats: () => {
    dispatch(chatCompanyLoadChatsSuccess({ items: [], totalCount: 0 }, true));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChatCompanyContainer)
);



// WEBPACK FOOTER //
// ./src/container/chat/ChatCompanyContainer/index.js